<!-- 毕业照片上传 -->
<template>
    <div class="el-studentPhoto">
        <el-row class="page_content">
            <h1 class="head_title">毕业照片上传</h1>
            <el-row style="padding-bottom:20px;">
                <el-col :span="5" style="text-align: center;min-width:200px;">
                    毕业照片预览
                </el-col>
                <el-col :span="4" style="padding-left:35px;min-width:200px;">
                    毕业照片上传
                </el-col>
            </el-row>
            <el-row style="padding-bottom:20px;min-width:200px;">
                <el-col :span="5" style="text-align: center;min-width:200px;">
                    <el-image :src="headImg" :preview-src-list="[headImg]"
                              style="border: 1px solid #f0f0f0;width: 160px;height: 228px;"/>
                </el-col>
                <el-col :span="4" style="min-width:200px;">
                    <el-upload
                        class="avatar-uploader"
                        :action="uploadUrl"
                        :headers="headers"
                        :disabled="dataInfo.studentPhotoState == 1"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <i class="el-icon-plus avatar-uploader-icon" title="点击上传"></i>
                    </el-upload>
                </el-col>
                <el-col :span="14" style="min-width:300px;">
                    <!-- studentPhotoConfirm:是否确认照片无误（1是 2否） -->
                    <!-- studentStatusState:状态（1已审核 2未审核 3不通过） -->
                    <p v-if='studentPhotoUrl != null && studentPhotoUrl !=""'>
                        照片状态：
                        <template v-if="dataInfo.studentPhotoConfirm == 2 || dataInfo.studentPhotoConfirm == null">
                            <span style="color: #b0adad;">未确认</span>
                            <el-button style="margin-left: 20px;" @click="centerDialogVisible = true" size="small"
                                       type="primary">确认照片
                            </el-button>

                        </template>
                        <template v-else>
                            <span style="color: #3967FF;" v-if="dataInfo.studentPhotoConfirm == 1">已确认无误</span>
                        </template>
                    </p>
                    <template v-if="dataInfo.studentPhotoState != null">
                        <p>
                            审核状态：
                            <span style="color: #3967FF;" v-if="dataInfo.studentPhotoState == 1">审核通过</span>
                            <span style="color: #b0adad;" v-if="dataInfo.studentPhotoState == 2">待审核</span>
                            <span style="color: red;" v-if="dataInfo.studentPhotoState == 3">审核未通过</span>
                        </p>
                        <p v-if="dataInfo.examineRemark != null && dataInfo.studentPhotoState == 3">
                            审核说明：
                            <span style="color: #b0adad;">{{ dataInfo.examineRemark }}</span>
                        </p>
                    </template>
                </el-col>
            </el-row>
            <el-row style="padding-bottom:20px;color:red;padding-left:50px;">
                <p>电子版图像要求：</p>
                <p>1、蓝色背景，图像不大于1M；</p>
                <p>2、图像“高”要求在 192 像素（px），“宽”要求在 144 像素（px）；</p>
                <p>
                    3、鉴于毕业照片的严肃性，请同学务必提交标准证件照，生活照、手机拍照、以及PS、美图等工具修复的照片均不予审核通过。</p>

            </el-row>
        </el-row>

        <el-dialog
            title="系统提示"
            :visible.sync="centerDialogVisible"
            width="30%"
        >
            <span>照片是否确认无误 ？</span>
            <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmPhoto">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
import headImg from '@/images/user/headImg.png';
import {getCookieForRoleTag} from "../../common/ulit";

export default {
    name: "StudentPhoto",
    data() {
        return {
            uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
            // headers: {token:this.$cookies.get("JT_S_02_token")}, //请求头
            headers: {token: getCookieForRoleTag(),"_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null,
            }, //请求头

            imageUrl: "",
            headImg: headImg,
            studentPhotoUrl: "",
            dataInfo: {},
            centerDialogVisible: false
        };
    },
    created() {
        this.getStudentGraduationPhoto();
    },
    methods: {
        handleAvatarSuccess(res, file) { //上传成功回调
            this.studentPhotoUrl = res.data.url; //准考证照片
            this.headImg = this.$baseUrl + res.data.url;
            this.addStudentGraduationPhoto();
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isLt5M = file.size / 1024 / 1024 <= 1;

            if (!isJPG && !isPNG) {
                this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                return false;
            }
            if (!isLt5M) {
                this.$message.error('上传头像图片大小不能超过 1MB!');
                return false;
            }
            return (isJPG || isPNG) && isLt5M;
        },
        getStudentGraduationPhoto() { //毕业照片查询 审核通过的就不能修改了
            this.$store.dispatch("user/getStudentGraduationPhoto", this.submitInfo)
                .then((ret) => {
                    if (ret.code === 0 || ret.code === '0') {
                        if (ret.studentPhoto != null) {
                            this.dataInfo = ret.studentPhoto;
                            this.studentPhotoUrl = ret.studentPhoto.studentPhotoUrl;
                            if (!this.$isEmpty(ret.studentPhoto.studentPhotoUrl)) {
                                this.headImg = this.$baseUrl + ret.studentPhoto.studentPhotoUrl;
                            }
                        }
                    } else {
                        this.$message({
                            message: ret.msg,
                            type: 'warning'
                        });
                    }
                }).catch((err) => {
            });
        },
        addStudentGraduationPhoto() { //毕业照片上传
            this.$store.dispatch("user/addStudentGraduationPhoto", {studentPhotoUrl: this.studentPhotoUrl})
                .then((ret) => {
                    if (ret.code === 0 || ret.code === '0') {
                        this.$message({
                            message: '保存成功！',
                            type: 'success'
                        });
                        this.getStudentGraduationPhoto();
                    } else {
                        this.$message({
                            message: ret.msg,
                            type: 'warning'
                        });
                    }
                }).catch((err) => {
            });
        }, confirmPhoto() { //确认照片
            this.$store.dispatch("user/confirmStudentGraduationPhoto")
                .then((ret) => {
                    this.centerDialogVisible = false;
                    if (ret.code === 0 || ret.code === '0') {
                        this.$message({
                            message: '确认成功！',
                            type: 'success'
                        });
                        this.getStudentGraduationPhoto();
                    } else {
                        this.$message({
                            message: ret.msg,
                            type: 'warning'
                        });
                    }
                }).catch((err) => {
                this.centerDialogVisible = false;
            });
        }
    }
};
</script>
<style lang="less">
@import '../../styles/base.less';

.el-studentPhoto {
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 160px;
        height: 228px;
        line-height: 228px;
        text-align: center;
    }

    .avatar {
        width: 160px;
        height: 228px;
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/GraduatePhoto.vue